// An error from the API, explained. explain: the page's own wording for the errors it expects;
// anything else gets the general line. A refusal (response.ts) always shows its own detail.

import { ApiError } from "../api.js";

export const GENERAL_ERROR = "Something went wrong. Try again, and tell IT if it keeps happening.";

export function ErrorNotice({ error, explain }: { error: unknown; explain?: (e: ApiError) => string | undefined }) {
  let text = GENERAL_ERROR;
  if (error instanceof ApiError) {
    if (error.body.error === "refused") text = String(error.body.detail);
    else text = explain?.(error) ?? GENERAL_ERROR;
  }
  return (
    <p className="notice" role="alert">
      {text}
    </p>
  );
}
